import React from "react";
import { ShieldCheck } from "lucide-react";

export default function AkilOnayPanel({ ozet, aciklama, onConfirm, onCancel, loading }) {
    const text = ozet || aciklama;
    if (!text) return null;
    return (
        <div className="rounded-xl border border-amber-500/40 bg-amber-500/10 p-4">
            <div className="flex items-start gap-3">
                <ShieldCheck className="h-5 w-5 text-amber-300 shrink-0 mt-0.5" />
                <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-amber-100">Onay gerekli</p>
                    <p className="text-xs text-amber-200/90 mt-1 whitespace-pre-wrap">{text}</p>
                    <div className="flex gap-2 mt-3">
                        <button
                            type="button"
                            onClick={onConfirm}
                            disabled={loading}
                            className="px-3 py-1.5 rounded-md bg-amber-500 text-black text-xs font-bold disabled:opacity-50"
                        >
                            Onayla ve Uygula
                        </button>
                        <button
                            type="button"
                            onClick={onCancel}
                            className="px-3 py-1.5 rounded-md border border-white/20 text-xs"
                        >
                            İptal
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
